module.exports = __webpack_public_path__ + "static/img/arduino_nano-2.b49ff41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/arduino_nano-2.svg
// module id = uaq4
// module chunks = 0